resourcePaths = '{"rootPath":"/member","assetsPath":"/member/assets"}';function ModelV1(_model, _handlers, _transferObj) {
    this.model = null;
    this.view = null;
    this.transferObj = null;
    this.handlers = null;

    this._viewToModelPathTree = new Object();
    this._elementModel = new Object();

    this._ACCEPT_HEADER = "application/vnd.mogo.v1";
    this._inputBindElements = {"input": "", "textarea": "", "select": ""};
    this._LOG = false;

    jQuery.fn.findAndSelf = function (selector){
        return this.find(selector).addBack(selector);
    };

    this.constructor = function(_model, _handlers, _transferObj) {
        // Set class variables
        this.model = _model;
        this.handlers = _handlers;
        this.transferObj = _transferObj;

        // Bind buttons
        this._initButtons();

        if (console.group && this._LOG)
            console.group("initialize");

        // Create view path and view model
        this._buildViewToModelPathAndViewModel();

        // Create element reference
        this._buildElementReference();

        // Bind data
        this.refreshFromModel();

        if (console.groupEnd && this._LOG)
            console.groupEnd("initialize");

        if (this._LOG)
            console.log(this.model);
    };

    this._buildViewToModelPathAndViewModel = function() {
        if (console.time && this._LOG)
            console.time("build view to model path and view model");

        // Check for root node
        if (Object.keys(this.transferObj).length != 1) {
            console.error("Model::View object must have root node");
            return;
        }

        // Create view and populate with values from model
        this.view = $.extend(true, {}, this.transferObj);
        this._findValues(this.view, Object.keys(this.view)[0], Object.keys(this.view)[0]);

        if (console.timeEnd && this._LOG)
            console.timeEnd("build view to model path and view model");
    };

    this._findValues = function(obj, key, currentPath) {
        if (typeof obj[key] == "object") {
            var keys = Object.keys(obj[key]);
            for (var i = 0; i < keys.length; i++) {
                this._findValues(obj[key], keys[i], currentPath + "." + keys[i]);
            }
        } else {
            try {
                var modelPath = obj[key];
                if (modelPath == "")
                    console.error("Model::Model property specified in view is blank");
                else {
                    var value = eval("this.model." + modelPath);
                    if (value === null) {
                        obj[key] = eval("this.model." + modelPath);

                        // Add to viewToModelPathTree
                        this._viewToModelPathTree[currentPath] = modelPath;
                    } else if (typeof value == "object") {
                        this._viewToModelPathTree[currentPath] = modelPath;
                        obj[key] = $.extend(true, {}, value);

                        var pathArray = new Array();
                        var path = currentPath;
                        this._findPaths(obj[key], "", pathArray);
                        for (var i = 0; i < pathArray.length; i++) {
                            // Add to viewToModelPathTree
                            this._viewToModelPathTree[path + pathArray[i]] = modelPath + pathArray[i];
                        }
                    } else {
                        obj[key] = eval("this.model." + modelPath);

                        // Add to viewToModelPathTree
                        this._viewToModelPathTree[currentPath] = modelPath;
                    }
                    if (obj[key] === undefined)
                        throw modelPath;
                }
            } catch (e) {
                console.error("Model::Property " + e + " does not exist in view");
                obj[key] = null;
            }
        }
    };

    this._findPaths = function(obj, currentPath, pathArray) {
        if (typeof obj == "object" && obj != null) {
            pathArray.push(currentPath);
            var keys = Object.keys(obj);
            for (var i = 0; i < keys.length; i++) {
                this._findPaths(obj[keys[i]], currentPath + "." + keys[i], pathArray);
            }
        } else {
            pathArray.push(currentPath);
        }
    };

    this._findModelPaths = function(viewPath, pathArray) {
        // Find model/view paths using transfer object
        var transferModel = eval("this.transferObj." + viewPath);
        for (var key in transferModel) {
            if (typeof transferModel[key] === 'string') {
                pathArray.push({"viewPath": viewPath + "." + key, "modelPath": transferModel[key]});
            } else if (typeof transferModel[key] == 'object') {
                pathArray = this._findModelPaths(viewPath + "." + key, pathArray);
            }
        }
        return pathArray;
    };

    this._buildElementReference = function() {
        if (console.time && this._LOG)
            console.time("build element reference");

        var id_gen = 0;

        var dataBinds = $("[data-bind], [data-bind-view]");
        for (var i = 0; i < dataBinds.length; i++) {
            var elementReference = new Object();

            // Get data-bind element
            var dataBindElem = dataBinds[i];

            // Check for ID or generate
            if ($(dataBindElem).attr("id") == null || $(dataBindElem).attr("id").trim() == "") {
                $(dataBindElem).attr("id", "mg_" + id_gen);
                id_gen++;
            }
            var nodeId = $(dataBindElem).attr("id");

            // Get path
            var groupBinding = "";
            var dataBindElemParents = $(dataBindElem).parents("[data-bind-group]");
            for (var j = 0; j < dataBindElemParents.length; j++) {
                groupBinding = "." + $(dataBindElemParents[j]).data("bind-group").trim() + groupBinding;
            }

            var references = new Array();
            var viewOnly = true;
            var binders = null;
            var viewFormatters = $(dataBindElem).data("format-view");
            if (viewFormatters != undefined)
                viewFormatters = viewFormatters.split(",")
            var commitFormatters = $(dataBindElem).data("format-commit");
            if (commitFormatters != undefined)
                commitFormatters = commitFormatters.split(",");
            if ($(dataBindElem).data("bind")) {
                binders = $(dataBindElem).data("bind");
                viewOnly = false;
            } else {
                binders = $(dataBindElem).data("bind-view");
            }
            binders = binders.split(",");
            for (var j = 0; j < binders.length; j++) {
                var referenceObj = new Object();
                var viewReference = new Object();

                var propertyName = binders[j].trim();
                var vRefStr = "this.view" + groupBinding + "." + propertyName.trim();
                var vRefFull = (groupBinding + "." + propertyName.trim()).substring(1);
                var vRef = eval(vRefStr.substring(0, vRefStr.lastIndexOf(".")));
                viewReference.reference = vRef;
                viewReference.propertyName = vRefStr.substring(vRefStr.lastIndexOf(".") + 1);
                viewReference.fullViewPath = vRefFull;

                // Formatters
                var vFormatters = null;
                if (viewFormatters != undefined) {
                    var vFormatters = new Array();
                    var currentFormatters = viewFormatters[j];
                    if (currentFormatters != undefined) {
                        currentFormatters = currentFormatters.trim().split(" ");
                        for (var k = 0; k < currentFormatters.length; k++) {
                            var currentFormatter = currentFormatters[k];
                            if (typeof this.handlers[currentFormatter] == "function") {
                                vFormatters[k] = currentFormatter;
                            } else if (typeof this.handlers[currentFormatter.toLowerCase()] == "function") {
                                vFormatters[k] = currentFormatter;
                            } else {
                                // Built-in formats
                                currentFormatter = currentFormatter.toLowerCase();
                                if (currentFormatter == "capitalize" ||
                                    currentFormatter == "lowercase" ||
                                    currentFormatter == "uppercase" ||
                                    currentFormatter == "street" ||
                                    currentFormatter == "phone" ||
                                    currentFormatter == "boolean" ||
                                    currentFormatter == "date" ||
                                    currentFormatter == "null-hide-self" ||
                                    currentFormatter == "null-hide-parent") {
                                    vFormatters[k] = currentFormatter;
                                } else {
                                    console.error("Model::Cannot find data view formatter: " + currentFormatter);
                                }
                            }
                        }
                    }
                }

                // Commit formatters
                var cFormatters = null;
                if (commitFormatters != undefined) {
                    var cFormatters = new Array();
                    var currentFormatters = commitFormatters[j];
                    if (currentFormatters != undefined) {
                        currentFormatters = currentFormatters.trim().split(" ");
                        for (var k = 0; k < currentFormatters.length; k++) {
                            var currentFormatter = currentFormatters[k];
                            if (typeof this.handlers[currentFormatter] == "function") {
                                cFormatters[k] = currentFormatter;
                            } else if (typeof this.handlers[currentFormatter.toLowerCase()] == "function") {
                                cFormatters[k] = currentFormatter;
                            } else {
                                // Built-in formats
                                currentFormatter = currentFormatter.toLowerCase();
                                if (currentFormatter == "capitalize" ||
                                    currentFormatter == "lowercase" ||
                                    currentFormatter == "uppercase" ||
                                    currentFormatter == "street" ||
                                    currentFormatter == "phone" ||
                                    currentFormatter == "boolean" ||
                                    currentFormatter == "date") {
                                    cFormatters[k] = currentFormatter;
                                } else {
                                    console.error("Model::Cannot find data commit formatter: " + currentFormatter);
                                }
                            }
                        }
                    }
                }

                // Assign properties to reference object
                referenceObj.viewReference = viewReference;
                referenceObj.formatters = vFormatters;
                referenceObj.commitFormatters = cFormatters;
                references[j] = referenceObj;
            }

            // Find bind handlers
            var bindHandler = null;
            if ($(dataBindElem).data("bind-handler")) {
                // User defined bind handlers
                bindHandler = $(dataBindElem).data("bind-handler").trim();

                // User defined bind handlers
                if (typeof this.handlers[bindHandler] == "function") {
                    bindHandler = bindHandler;
                } else if (typeof this.handlers[binder.toLowerCase()] == "function") {
                    bindHandler = bindHandler.toLowerCase();
                } else {
                    // Built-in handlers

                    console.error("Model::Cannot find data bind handler: " + bindHandler);
                    bindHandler = null;
                }
            }

            elementReference = new Object();
            elementReference.viewOnly = viewOnly;
            elementReference.references = references;
            elementReference.bindHandler = bindHandler;
            this._elementModel[nodeId] = elementReference;
        }

        if (console.timeEnd && this._LOG)
            console.timeEnd("build element reference");
    };

    this.refreshFromModel = function(node) {
        if (console.time && this._LOG)
            console.time("refresh from model");

        var dataBinds = [];
        if (node == null)
            dataBinds = $("[data-bind], [data-bind-view]", node);
        else
            dataBinds = $(node).findAndSelf("[data-bind], [data-bind-view]");
        for (var i = 0; i < dataBinds.length; i++) {
            var nodeId = dataBinds[i].id;
            var metaData = this._elementModel[nodeId];

            // Get data
            var data = new Array();
            var references = metaData.references;
            for (var j = 0; j < references.length; j++) {
                var reference = references[j];
                data[j] = (reference.viewReference.reference)[reference.viewReference.propertyName];
                if (reference.formatters != null) {
                    for (var k = 0; k < reference.formatters.length; k++) {
                        var formatter = reference.formatters[k];
                        // Special formatters
                        if (formatter != null) {
                            if (formatter == "null-hide-parent") {
                                if (data[j] == null)
                                    $(dataBinds[i]).parent().css("display", "none");
                                else
                                    $(dataBinds[i]).parent().css("display", "");
                            } else if (formatter == "null-hide-self") {
                                if (data[j] == null)
                                    $(dataBinds[i]).css("display", "none");
                                else
                                    $(dataBinds[i]).css("display", "");
                            } else {
                                data[j] = this._format(data[j], formatter);
                            }
                        }
                    }
                }
            }

            // Bind data
            if (metaData.bindHandler) {
                this._bind(metaData.bindHandler, dataBinds[i], data);
            } else {
                this._bind(null, dataBinds[i], data);
            }
        }

        if (console.timeEnd && this._LOG)
            console.timeEnd("refresh from model");
    };

    this.refreshFromRemote = function(node, full, evt) {
        if (console.time && this._LOG)
            console.time("refresh from remote");

        // Visual wait indicators
        this._activateWaitIndicators();

        var updateModels = new Object();
        var dataBinds = [];
        if (node == null)
            dataBinds = $("[data-bind], [data-bind-view]", node);
        else
            dataBinds = $(node).findAndSelf("[data-bind], [data-bind-view]");
        for (var i = 0; i <  dataBinds.length; i++) {
            var dataBind = dataBinds[i];
            var references = this._elementModel[dataBind.id].references;
            for (var j = 0; j < references.length; j++) {
                var fullViewPath = references[j].viewReference.fullViewPath;
                var modelPaths = this._viewToModelPathTree[fullViewPath];
                if (modelPaths != null) {
                    modelPaths = [{"viewPath": fullViewPath, "modelPath": modelPaths}];
                } else {
                    var modelPaths = new Array();
                    modelPaths = this._findModelPaths(fullViewPath, modelPaths);
                }

                for (var k = 0; k < modelPaths.length; k++) {
                    var modelPath = modelPaths[k].modelPath;
                    var viewPath = modelPaths[k].viewPath;
                    var tempModelPath = modelPath.substring(0, modelPath.lastIndexOf("."));
                    var linksObj = null;
                    var found = false;
                    while (!found) {
                        linksObj = eval("this.model." + tempModelPath + ".links");
                        if (linksObj != null) {
                            found = true;
                        } else {
                            tempModelPath = tempModelPath.substring(0, tempModelPath.lastIndexOf("."));
                        }
                    }
                    // If field is updatable
                    if (linksObj.self_link) {
                        var updateModel = updateModels[linksObj.self_link.uri];
                        if (updateModel == undefined) {
                            updateModel = new Object();
                            updateModel.updateMethod = linksObj.self_link.action;
                            var tempStr = tempModelPath.substring(0, tempModelPath.lastIndexOf(".")) == "" ? "" : "." + tempModelPath.substring(0, tempModelPath.lastIndexOf("."));
                            updateModel.modelReference = eval("this.model" + tempStr);
                            updateModel.modelPropertyName = tempModelPath.substring(tempModelPath.lastIndexOf(".") + 1);
                            updateModel.fields = new Object();
                            updateModels[linksObj.self_link.uri] = updateModel;
                        }
                        if (updateModel.fields[dataBind.id] == undefined) {
                            var field = new Object();
                            field.node = dataBind;
                            field.propertyName = viewPath.substring(viewPath.lastIndexOf(".") + 1);
                            updateModel.fields[dataBind.id] = field;
                        } else {
                            updateModel.fields[dataBind.id].propertyName = updateModel.fields[dataBind.id].propertyName + "," + viewPath.substring(viewPath.lastIndexOf(".") + 1);
                        }
                    }
                }
            }
        }

        // Create and call ajax requests
        var requests = new Array();
        updateModels = this._optimizeRequests(updateModels);
        $.support.cors = true;
        for (var key in updateModels) {
            if (updateModels[key] == undefined)
                continue;

            var fields = updateModels[key].fields;
            var params = {
                url: key,
                type: updateModels[key].updateMethod.toUpperCase(),
                headers: {
                    "Accept": this._ACCEPT_HEADER,
                    "Content-Type": "application/json"
                },
                cache: false,
                dataType: "json",
                success: $.proxy(this._refreshRemoteSuccess, this, fields, node, {modelReference: updateModels[key].modelReference[updateModels[key].modelPropertyName]}, evt),
                error: $.proxy(this._refreshRemoteFailure, this, fields, node, evt)
            };
            requests.push($.ajax(params));
        }
        $.support.cors = true;
        $.when.apply(undefined, requests).then($.proxy(this._refreshRemoteCollectiveSuccess, this, node, full, evt), $.proxy(this._refreshRemoteFailureCollective, this));
    };

    this._refreshRemoteSuccess = function(fields, node, modelRef, evt, data) {
        // Copy result to model
        $.extend(true, modelRef.modelReference, data[Object.keys(data)[0]]);

        // Rebuild view and and element model
        this._buildViewToModelPathAndViewModel();
        this._buildElementReference();

        if (console.timeEnd && this._LOG)
            console.timeEnd("refresh from remote");
    };

    this._refreshRemoteFailure = function(fields, node, evt, error) {
        var errorObj = new Object();
        errorObj.error_code = error.status;
        errorObj.error_description = error.statusText;

        // Failure callback
        if (typeof this.handlers["commit-refresh-remote-failure"] == "function") {
            this.handlers["commit-refresh-remote-failure"](evt, errorObj);
        }

        if (console.timeEnd && this._LOG)
            console.timeEnd("refresh from remote");
    };

    this._refreshRemoteCollectiveSuccess = function(node, full, evt) {
        // Refresh model
        if (full != null && full)
            this.refreshFromModel();
        else
            this.refreshFromModel(node);

        // Success callback
        if (typeof this.handlers["commit-refresh-remote-success"] == "function") {
            this.handlers["commit-refresh-remote-success"](evt);
        }

        // Deactivate visual wait indicators
        this._deactivateWaitIndicators();

        if (console.timeEnd && this._LOG)
            console.timeEnd("refresh from remote");
    };

    this._refreshRemoteFailureCollective = function() {
        // Deactivate visual wait indicators
        this._deactivateWaitIndicators();
    };

    this.refreshFromOrigin = function(node, evt) {
        // Implemented at a later time
        // Revert view model (including any saveToModel calls) back to current model object
        // (without hitting server)
    };

    this.saveToModel = function(node) {
        if (console.time && this._LOG)
            console.time("save to model");

        // Get all data-bind elements
        var dataBinds = [];
        if (node == null)
            dataBinds = $("[data-bind]", node);
        else
            dataBinds = $(node).findAndSelf("[data-bind]");
        for (var i = 0; i < dataBinds.length; i++) {
            var nodeId = dataBinds[i].id;
            var metaData = this._elementModel[nodeId];

            // Retrieve data
            var data = null;
            if (metaData.bindHandler) {
                data = this._bind(metaData.bindHandler, dataBinds[i]);
            } else {
                data = this._bind(null, dataBinds[i]);
            }

            // Format data - data returned must be of type array - each value in array corresponds to each data-bind value
            if ($.isArray(data)) {
                var formatters = metaData.commitFormatters;
                if (formatters != null) {
                    for (var j = 0; j < formatters.length; j++) {
                        if (formatters[j] != null)
                            data[j] = this._format(data[j], formatters[j]);
                    }
                }
            } else {
                console.error("Model::Bind Handler " + metaData.bindHandler + " must return type of Array");
            }

            // Save data to view model
            var references = metaData.references;
            for (var j = 0; j < references.length; j++) {
                if (data[j] !== undefined) {
                    references[j].viewReference.reference[references[j].viewReference.propertyName] = data[j];
                }
            }
        }

        if (console.timeEnd && this._LOG)
            console.timeEnd("save to model");
    };

    this.persistModel = function(node, evt) {
        if (console.time && this._LOG)
            console.time("persist model");

        // Visual wait indicators
        this._activateWaitIndicators();

        // Save to view model
        this.saveToModel(node);

        // Transfer to object model
        var updateModels = new Object();
        var dataBinds = [];
        if (node == null)
            dataBinds = $("[data-bind]", node);
        else
            dataBinds = $(node).findAndSelf("[data-bind]");
        for (var i = 0; i < dataBinds.length; i++) {
            var dataBind = dataBinds[i];
            var references = this._elementModel[dataBind.id].references;
            for (var j = 0; j < references.length; j++) {
                var fullViewPath = references[j].viewReference.fullViewPath;
                var modelPaths = this._viewToModelPathTree[fullViewPath];
                if (modelPaths != null) {
                    modelPaths = [{"viewPath": fullViewPath, "modelPath": modelPaths}];
                } else {
                    var modelPaths = new Array();
                    modelPaths = this._findModelPaths(fullViewPath, modelPaths);
                }

                for (var k = 0; k < modelPaths.length; k++) {
                    var modelPath = modelPaths[k].modelPath;
                    var viewPath = modelPaths[k].viewPath;
                    var tempModelPath = modelPath.substring(0, modelPath.lastIndexOf("."));
                    var linksObj = null;
                    var found = false;
                    while (!found) {
                        linksObj = eval("this.model." + tempModelPath + ".links");
                        if (linksObj != null) {
                            found = true;
                        } else {
                            tempModelPath = tempModelPath.substring(0, tempModelPath.lastIndexOf("."));
                        }
                    }
                    // If field is updatable
                    if (linksObj.update_link) {
                        var updateModel = updateModels[linksObj.update_link.uri];
                        if (updateModel == undefined) {
                            updateModel = new Object();
                            updateModel.updateMethod = linksObj.update_link.action;
                            updateModel.modelRollbackReference = eval("this.model." + tempModelPath);
                            updateModel.modelRollbackObject = $.extend(true, {}, updateModel.modelRollbackReference);
                            var tempStr = tempModelPath.substring(0, tempModelPath.lastIndexOf(".")) == "" ? "" : "." + tempModelPath.substring(0, tempModelPath.lastIndexOf("."));
                            updateModel.modelReference = eval("this.model" + tempStr);
                            updateModel.modelPropertyName = tempModelPath.substring(tempModelPath.lastIndexOf(".") + 1);
                            updateModel.fields = new Object();
                            updateModels[linksObj.update_link.uri] = updateModel;
                        }
                        if (updateModel.fields[dataBind.id] == undefined) {
                            var field = new Object();
                            field.node = dataBind;
                            field.propertyName = viewPath.substring(viewPath.lastIndexOf(".") + 1);
                            updateModel.fields[dataBind.id] = field;
                        } else {
                            updateModel.fields[dataBind.id].propertyName = updateModel.fields[dataBind.id].propertyName + "," + viewPath.substring(viewPath.lastIndexOf(".") + 1);
                        }

                        // Transfer data to object model
                        var updatePropertyParent = eval("this.model." + modelPath.substring(0, modelPath.lastIndexOf(".")));
                        var updateProperty = modelPath.substring(modelPath.lastIndexOf(".") + 1);
                        updatePropertyParent[updateProperty] = eval("this.view." + viewPath);
                    }
                }
            }
        }

        // Create and call ajax requests
        var requests = new Array();
        $.support.cors = true;
        updateModels = this._optimizeRequests(updateModels);
        for (var key in updateModels) {
            if (updateModels[key] == undefined)
                continue;

            var persistingObj = new Object();
            persistingObj[updateModels[key].modelPropertyName] = updateModels[key].modelReference[updateModels[key].modelPropertyName];
            var fields = updateModels[key].fields;
            var modelRollback = updateModels[key].modelRollbackObject;
            var modelRollbackReference = updateModels[key].modelRollbackReference;
            var params = {
                url: key,
                type: updateModels[key].updateMethod.toUpperCase(),
                headers: {
                    "Accept": this._ACCEPT_HEADER,
                    "Content-Type": "application/json"
                },
                cache: false,
                data: JSON.stringify(persistingObj),
                dataType: "json",
                success: $.proxy(this._persistSuccess, this, fields, node, {modelReference: modelRollbackReference}, evt),
                error: $.proxy(this._persistFailure, this, fields, node, {modelRollback: modelRollback, modelRollbackReference: modelRollbackReference}, evt)
            };
            requests.push($.ajax(params));
        }
        $.support.cors = true;
        $.when.apply(undefined, requests).then($.proxy(this._persistSuccessCollective, this, node, evt), $.proxy(this._persistFailureCollective, this));
    };

    this._persistSuccess = function(fields, node, modelRef, evt, data) {
        // Copy result to model
        $.extend(true, modelRef.modelReference, data[Object.keys(data)[0]]);

        // Rebuild view and and element model
        this._buildViewToModelPathAndViewModel();
        this._buildElementReference();

        if (console.timeEnd && this._LOG)
            console.timeEnd("persist model");
    };

    this._persistFailure = function(fields, node, rollbackObj, evt, error) {
        var errorObj = new Object();
        errorObj.error_code = error.status;
        errorObj.error_description = error.statusText;
        if (error.status == 422) {
            // Parse Error and find path
            var errorJSON = error.responseJSON;

            errorObj.error_messages = new Array();

            for (var key in errorJSON.error_messages) {
                // Create field error object
                var fieldErrorObj = new Object();
                fieldErrorObj.originalTarget = key;
                fieldErrorObj.message = errorJSON.error_messages[key][0];

                var possibleNodes = new Array();
                for (var field_name in fields) {
                    if (key == fields[field_name].propertyName) {
                        // Add to possible nodes
                        possibleNodes.push(fields[field_name].node);
                    }
                }

                // Push result to field error object
                fieldErrorObj.calculatedTargets = possibleNodes;

                // Push object to array of error messages
                errorObj.error_messages.push(fieldErrorObj);
            }
        }

        // Rollback model
        $.extend(true, rollbackObj.modelRollbackReference, rollbackObj.modelRollback);

        // Rebuild view and and element model
        this._buildViewToModelPathAndViewModel();
        this._buildElementReference();

        // Failure callback
        if (typeof this.handlers["commit-persist-failure"] == "function") {
            this.handlers["commit-persist-failure"](evt, errorObj);
        }

        if (console.timeEnd && this._LOG)
            console.timeEnd("persist model");
    };

    this._persistSuccessCollective = function(node, evt) {
        // Refresh model
        this.refreshFromModel(node);

        // Success callback
        if (typeof this.handlers["commit-persist-success"] == "function") {
            this.handlers["commit-persist-success"](evt);
        }

        // Deactivate visual wait indicators
        this._deactivateWaitIndicators();

        if (console.timeEnd && this._LOG)
            console.timeEnd("persist model");
    };

    this._persistFailureCollective = function() {
        // Deactivate visual wait indicators
        this._deactivateWaitIndicators();
    };

    this._initButtons = function() {
        // Refreshes
        var dataCommitRefreshes = $("[data-commit-refresh]");
        for (var i = 0; i < dataCommitRefreshes.length; i++) {
            var dataCommitRefresh = dataCommitRefreshes[i];
            $(dataCommitRefresh).on("click", $.proxy(this._commit, this, "refresh"));
        }

        // Saves
        var dataCommitSaves = $("[data-commit-save]");
        for (var i = 0; i < dataCommitSaves.length; i++) {
            var dataCommitSave = dataCommitSaves[i];
            $(dataCommitSave).on("click", $.proxy(this._commit, this, "save"));
        }

        // Persists
        var dataCommitPersists = $("[data-commit-persist]");
        for (var i = 0; i < dataCommitPersists.length; i++) {
            var dataCommitPersist = dataCommitPersists[i];
            var form = $(dataCommitPersist).parents("form");
            if (form[0] != undefined && form[0].id != undefined && this.handlers["commit-validation"] != undefined && this.handlers["commit-validation"][form[0].id] != undefined) {
                $(form[0]).mogo().create("Validation", {validationObj: this.handlers["commit-validation"][form[0].id], callback: $.proxy(this._onValidate, this, "persist")});
            } else {
                $(dataCommitPersist).on("click", $.proxy(this._commit, this, "persist"));
            }
        }
    };

    this._onValidate = function(type, result, evt) {
        var createdTarget = evt;
        if ($(createdTarget.currentTarget).data("commit-" + type) == undefined ) {
            var target = $("[data-commit-" + type + "]", evt.currentTarget)[0];
            createdTarget = {target: target, currentTarget: target};
        }
        if (result) {
            this._commit(type, createdTarget);
        } else if (this.handlers["commit-validation-error"] != undefined && typeof this.handlers["commit-validation-error"] == "function") {
            this.handlers["commit-validation-error"](evt);
        }
        return false;
    };

    this._commit = function(type, evt) {
        var param = $(evt.target).data("commit-" + type);
        if (param != "part") {
            param = null;
        } else {
            param = $(evt.target).parents("[data-bind-group]")[0];
        }

        // Before callback
        var result = true;
        if (typeof this.handlers["commit-" + type + "-before"] == "function") {
            result = this.handlers["commit-" + type + "-before"](evt);
        }

        // Refresh Model
        if (result) {
            if (type == "refresh") {
                this.refreshFromModel(param);
            } else if (type == "refresh-remote") {
                this.refreshFromRemot(param, null, evt);
            } else if (type == "save") {
                this.saveToModel(param);
                this.refreshFromModel(param);
            } else if (type == "persist") {
                this.persistModel(param, evt);
            }
        }

        // Complete callback
        if (typeof this.handlers["commit-" + type] == "function") {
            this.handlers["commit-" + type](evt);
        }
    };

    this._optimizeRequests = function(requests) {
        try {
            var keys = Object.keys(requests);
            if (keys.length == 1)
                return requests;

            // Optimize requests
            var optimizedKeys = new Array();
            for (var i = 0; i < keys.length; i++) {
                var key = keys[i];
                var match = false;
                for (var j = 0; j < optimizedKeys.length; j++) {
                    if (optimizedKeys[j] != key) {
                        if (optimizedKeys[j].length < key.length && key.indexOf(optimizedKeys[j]) == 0) {
                            match = true;
                        } else if (key.length < optimizedKeys[j].length && optimizedKeys[j].indexOf(key) == 0) {
                            optimizedKeys[j] = key;
                            match = true;
                        }
                    }
                }

                if (!match)
                    optimizedKeys.push(key);
            }

            for (var key in requests) {
                var match = false;
                for (var j = 0; j < optimizedKeys.length; j++) {
                    if (optimizedKeys[j] == key) {
                        match = true;
                    }
                }
                if (!match) {
                    requests[key] = undefined;
                }
            }
            return requests;
        } catch (e) {
            return requests;
        }
    };

    this._activateWaitIndicators = function() {
        $("body").first().css("cursor", "wait");
    };

    this._deactivateWaitIndicators = function() {
        $("body").first().css("cursor", "auto");
    };

    this._format = function(str, formatter) {
        try {
            // User-defined formats
            if (typeof this.handlers[formatter] == "function") {
                str = this.handlers[formatter](str);
            } else {
                // Built-in formats
                if (formatter == "capitalize") {
                    str = this._dataFormatCapitalize(str);
                } else if (formatter == "lowercase") {
                    str = this._dataFormatLowerCase(str);
                } else if (formatter == "uppercase") {
                    str = this._dataFormatUpperCase(str);
                } else if (formatter == "street") {
                    str = this._dataFormatStreet(str);
                } else if (formatter == "phone") {
                    str = this._dataFormatPhone(str);
                } else if (formatter == "boolean") {
                    str = this._dataFormatBoolean(str);
                } else if (formatter == "date") {
                    str = this._dataFormatDate(str);
                }
            }
        } catch (e) {
            console.error("Model::Data formatter error: " + formatter);
        }

        return str;
    };

    this._bind = function(handler, dataBindElem, data) {
        if (handler != null) {
            // Custom handlers
            try {
                if (data != undefined) {
                    // Bind data to element
                    this.handlers[handler](dataBindElem, data);
                } else {
                    // Retrieve data from element
                    return this.handlers[handler](dataBindElem);
                }
            } catch (e) {
                console.log("Model::Error in data bind handler" + handler);
                console.log(e);
            }
        } else {
            // Default handler
            if (data != undefined) {
                // Bind data to element
                data = data.join(" ");

                var tagName = $(dataBindElem)[0].tagName.toLowerCase();
                if (this._inputBindElements[tagName] != undefined) {
                    // Form elements
                    var type = $(dataBindElem)[0].type.toLowerCase();
                    if (tagName == "select") {
                        this._dataBinderSelector(dataBindElem, data);
                    } else {
                        if (type != "radio" && type != "checkbox") {
                            if ($(dataBindElem).mogo().val)
                                $(dataBindElem).mogo().val(data)
                            else
                                $(dataBindElem).val(data);
                        } else if (type == "radio") {
                            this._dataBindRadio(dataBindElem, data);
                        }
                    }
                } else {
                    // Other elements
                    $(dataBindElem).html(data);
                }
            } else {
                // Retrieve data from element
                var tagName = $(dataBindElem)[0].tagName.toLowerCase();
                if (this._inputBindElements[tagName] != undefined) {
                    // Form elements
                    var type = $(dataBindElem)[0].type.toLowerCase();
                    if (tagName == "select") {
                        return this._dataBinderSelector(dataBindElem);
                    } else {
                        if (type != "radio" && type != "checkbox")
                            return [$(dataBindElem).val()];
                        else if (type == "radio")
                            return this._dataBindRadio(dataBindElem, data);
                    }
                } else {
                    // Other elements
                    return [$(dataBindElem).html().trim()];
                }
            }
        }
    };

    this._dataFormatCapitalize = function(data) {
        if (data != null)
            return data.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
        return null;
    };

    this._dataFormatLowerCase = function(data) {
        if (data != null)
            return data.toLowerCase();
        return null;
    };

    this._dataFormatUpperCase = function(data) {
        if (data != null)
            return data.toUpperCase();
        return null;
    };

    this._dataFormatBoolean = function(data) {
        if (data == true)
            return "Yes";
        else
            return "No";
    };

    this._dataFormatDate = function(data) {
        var separator = "";
        // Detect separator
        if (data.indexOf("-") >= 0)
            separator = "-";
        else if (data.indexOf("/") >= 0)
            separator = "/";
        else if (data.indexOf(".") >= 0)
            separator = ".";
        if (separator == "")
            return "";

        var dateArr = data.split(separator);
        if (dateArr.length != 3)
            return "";

        // Get year, month, date
        var y, m, d;
        if (dateArr[0].length == 4 && dateArr[1].length == 2 && dateArr[2].length == 2) {
            // Assume YYYY-MM-DD
            y = dateArr[0];
            m = dateArr[1];
            d = dateArr[2];
        } else if (dateArr[0].length == 2 && dateArr[1].length == 2 && dateArr[2].length == 4) {
            // Assume MM-DD-YYYY
            y = dateArr[2];
            m = dateArr[0];
            d = dateArr[1];
        } else {
            // Unknown format
            return "";
        }

        // Validate date
        var date = new Date(y, m - 1, d);
        if (date.getFullYear() == y && date.getMonth() + 1 == m && date.getDate() == d)
            return y + "/" + m + "/" + d;
        else
            return "";
    };

    this._dataFormatStreet = function(data) {
        if (data == null)
            return null;

        data = this._dataFormatCapitalize(data);
        var dataArr = data.split(" ");
        for (var i = 0; i < dataArr.length; i++) {
            if (dataArr[i].length == 2) {
                dataArr[i] = dataArr[i].replace(/Ne/g, "NE").replace(/Nw/g, "NW").replace(/Se/g, "SE").replace(/Sw/g, "SW");
            }
        }

        data = dataArr.join(" ");

        return data;
    };

    this._dataFormatPhone = function(data) {
        if (data == null)
            return null;

        data = data.replace(/[^\d.]/g, "");

        if (data.length == 10) {
            data = "(" + data.substring(0, 3) + ")" + " " + data.substring(3, 6) + " " + data.substring(6, 10);
        }

        return data;
    };

    this._dataBinderSelector = function(dataElem, data) {
        if (data != undefined) {
            var rootNode = $(dataElem).parents(".input.select")[0];

            // Set new selection
            if ($(dataElem).mogo().val) {
                $(dataElem).mogo().val(data);
            } else {
                $(dataElem).val(data);

                // Find selected text and update display
                var selectedText= $(dataElem).find(":selected").text();
                $(".current", rootNode).html(selectedText);
                $("ul li", rootNode).removeClass("selected");
                $("ul li", rootNode).filter(":contains('" + selectedText + "')").addClass("selected");
            }
        } else {
            return [$(dataElem).val()];
        }
    };

    this._dataBindRadio = function(dataElem, data) {
        if (data != undefined) {
            if (data == $(dataElem).val()) {
                if ($(dataElem).mogo().setChecked != null) {
                    $(dataElem).mogo().setChecked(true);
                } else {
                    $(dataElem).attr("checked", true);
                    $($("span.custom.radio", $(dataElem).parent())[0]).addClass("checked");
                }
            } else {
                if ($(dataElem).mogo().setChecked != null)
                    $(dataElem).mogo().setChecked(false);
                else
                    $($("span.custom.radio", $(dataElem).parent())[0]).removeClass("checked");
            }
        } else {
            var radioGroupName;
            if ($(dataElem).mogo().group != null) {
                radioGroupName = $(dataElem).mogo().group;
            } else {
                radioGroupName = $(dataElem).attr("name");
            }
            if (radioGroupName != null) {
                return [$("input[name='" + radioGroupName + "']:checked").val()];
            } else {
                if (dataElem.checked) {
                    return [$("input[name='" + radioGroupName + "']:checked").val()];
                } else {
                    return "";
                }
            }
        }
    };

    this.constructor(_model, _handlers, _transferObj);
}